(() => {
	angular.module('main').directive('animateNewTask', animateNewTask);

	animateNewTask.$inject = [];

	function animateNewTask() {
		return {
			restrict: 'A',
			scope: {},
			link(scope) {
				scope.$on('animateTask', animateNewTask);

				function animateNewTask(event, taskToAnimate) {
					const TOP_SPACE = 200;

					const taskOffsetTop = $(taskToAnimate).offset().top;

					$('html, body').animate(
						{
							scrollTop: taskOffsetTop - TOP_SPACE
						},
						1500,
						() => {
							const animationClass = 'animated tada';
							$(taskToAnimate).addClass(animationClass);
						}
					);
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/animateNewTask.js